// giusp.com grn@giusp.com

export function pass(phrasal_number) {
    let circleSuccessStyle = "badge badge-rounded-circle text-bg-success-subtle mt-1 me-4";
    let circleSuccessIcon = "<i class=\"fe fe-check\"></i>";
    let name = phrasal_number + "_check_frame";
    document.getElementById(name).className = circleSuccessStyle;
    document.getElementById(name).innerHTML = circleSuccessIcon;
}

export function neutral(phrasal_number) {
    let circleNeutralStyle = "badge badge-rounded-circle text-bg-info-subtle mt-1 me-4";
    let circleNeutralIcon = "<i class=\"\"></i>";
    let name = phrasal_number + "_check_frame";
    document.getElementById(name).className = circleNeutralStyle;
    document.getElementById(name).innerHTML = circleNeutralIcon;
}

export function fail(phrasal_number) {
    let circleFailStyle = "badge badge-rounded-circle text-bg-danger-subtle mt-1 me-4";
    let circleFailIcon = "<i class=\"fe fe-x\"></i>";
    let name = phrasal_number + "_check_frame";
    document.getElementById(name).className = circleFailStyle;
    document.getElementById(name).innerHTML = circleFailIcon;
}

export function styleAsIsValid(element) {
    element.classList.remove("is-invalid");
    element.classList.add("is-valid");
    document.getElementById("serviceFormSendButton").removeAttribute("disabled");
}

export function styleAsIsInvalid(element) {
    element.classList.remove("is-valid");
    element.classList.add("is-invalid");
    document.getElementById("serviceFormSendButton").setAttribute("disabled", "disabled");
}

// To close the dialog about answer/error when sending the form
function closeCard(button) {
    $(button).closest('.card').hide();
}
window.closeCard = closeCard;

// Another style handler for the closable card
document.addEventListener("DOMContentLoaded", function () {
    let el = document.getElementById("closable1");

    if (el) {
        document.getElementById("closable1").addEventListener('click', function () {
            document.getElementById('formLiquidSectionDependent').classList.remove(...document.getElementById('formLiquidSectionDependent').classList);
            document.getElementById('formLiquidSectionDependent').classList.add("pb-0");
            document.getElementById('formLiquidSectionDependent').classList.add("pb-md-7");

            document.getElementById('cardLiquidSectionDependent').classList.remove(...document.getElementById('cardLiquidSectionDependent').classList);
            document.getElementById('cardLiquidSectionDependent').classList.add("pt-7");
            document.getElementById('cardLiquidSectionDependent').classList.add("pt-md-0");
            document.getElementById('cardLiquidSectionDependent').classList.add("pb-7");
            document.getElementById('cardLiquidSectionDependent').classList.add("pb-md-7");
        });
    }
});
